// store/index.js
/* eslint-disable-next-line */
import { createStore } from 'vuex';
/* eslint-disable-next-line */
import axios from 'axios';

/* eslint-disable-next-line */
const queryString = require('query-string');

const getMagazinPageEntry = (post, magazineCat) => {
    if (!post.acf?.magazinPages?.length) {
        return null;
    }

    const exact = post.acf.magazinPages.find((entry) => entry.cat === magazineCat);
    if (exact) {
        return exact;
    }

    if (post.magazinecat?.some((cat) => cat === magazineCat)) {
        return post.acf.magazinPages[0];
    }

    return null;
};

const normalizeImageUrl = (_value) => {
    if (_value === null || _value === undefined || _value === false) return null;
    const v = String(_value).trim();
    if (!v || v === 'false' || v === 'undefined' || v === 'null') return null;
    return v;
};

/** REST/ACF kann thumb.url als false liefern — sonst entsteht z. B. src "false.webp". */
const sanitizePostThumb = (post) => {
    if (!post || typeof post !== 'object') return post;
    const { thumb } = post;
    if (!thumb || typeof thumb !== 'object') return post;
    const url = normalizeImageUrl(thumb.url);
    if (!url) {
        return { ...post, thumb: null };
    }
    return {
        ...post,
        thumb: {
            ...thumb,
            url,
            urllarge: normalizeImageUrl(thumb.urllarge) || undefined,
            webpUrl: normalizeImageUrl(thumb.webpUrl) || undefined,
        },
    };
};

const store = createStore({
    state: {
        posts: [],
        filteredPosts: [],
        pages: [],
        startPage: undefined,
        menuState: false,
        magazineCat: null,
        postCount: null,
        prevPost: null,
        nextPost: null,
        currentIdInMagazine: false,
        magazineCatData: null,
        manuelOverridePosts: null,
    },
    getters: {
        getPosts: (state) => state.posts,
        getFilteredPosts: (state) => state.filteredPosts,
        getPages: (state) => state.pages,
        getStartPage: (state) => state.startPage,
        getPostCount: (state) => state.postCount,
        getPrevPost: (state) => state.prevPost,
        getNextPost: (state) => state.nextPost,
        getMenuState: (state) => state.menuState,
        getMagazineCat: (state) => state.magazineCat,
        getCurrentIdInMagazine: (state) => state.currentIdInMagazine,
        getMagazineCatData: (state) => state.magazineCatData,
        getManuelOverridePosts: (state) => state.manuelOverridePosts,
    },
    mutations: {
        SET_POSTS: (state, res) => {
            state.posts = Array.isArray(res) ? res.map(sanitizePostThumb) : res;
        },
        SET_FILTERED_POSTS: (state, res) => {
            state.filteredPosts = Array.isArray(res) ? res.map(sanitizePostThumb) : res;
        },
        SET_PAGES: (state, res) => {
            state.pages = Array.isArray(res) ? res.map(sanitizePostThumb) : res;
        },
        SET_START_PAGE: (state, res) => {
            state.startPage = res ? sanitizePostThumb(res) : res;
        },
        SET_MENU_STATE: (state, res) => {
            state.menuState = res;
        },
        SET_MAGAZINE_CAT: (state, res) => {
            state.magazineCat = res;
        },
        SET_POST_COUNT: (state, res) => {
            state.postCount = res;
        },
        SET_PREV_POST: (state, res) => {
            state.prevPost = res ? sanitizePostThumb(res) : res;
        },
        SET_NEXT_POST: (state, res) => {
            state.nextPost = res ? sanitizePostThumb(res) : res;
        },
        SET_CURRENT_ID_IN_MAGAZINE: (state, res) => {
            state.currentIdInMagazine = res;
        },
        SET_MAGAZINE_CAT_DATA: (state, res) => {
            state.magazineCatData = res;
        },
        SET_MANUEL_OVERRIDE_POSTS: (state, res) => {
            state.manuelOverridePosts = res;
        },
    },
    actions: {
        getCurrentIdInMagazine({ state, commit }) {
            /* eslint-disable-next-line */
            const currentId = parseInt(wpUrls.currentID, 10);
            const currentIdInPosts = state.filteredPosts.find((post) => post.id === currentId);
            let idInMagazine = false;

            if (currentIdInPosts || (state.startPage && state.startPage.id === currentId)) {
                idInMagazine = true;
            }

            commit('SET_CURRENT_ID_IN_MAGAZINE', idInMagazine);
        },
        setMenuState({ commit }, status) {
            if (status) {
                document.body.classList.add('open');
            } else {
                document.body.classList.remove('open');
            }

            commit('SET_MENU_STATE', status);
        },
        async setManuelOverridePosts({ state, commit }) {
            let manualMenuItems = null;

            /* eslint-disable */
            if (state.magazineCatData !== null && state.magazineCatData !== undefined) {
                if (state.magazineCatData._restApiFailed) {
                    if (typeof wpUrls !== 'undefined' && wpUrls.manualMenuItems
                        && Array.isArray(wpUrls.manualMenuItems) && wpUrls.manualMenuItems.length > 0) {
                        manualMenuItems = wpUrls.manualMenuItems;
                    }
                } else if (state.magazineCatData.acf && state.magazineCatData.acf.manualMenuItems) {
                    const acfItems = state.magazineCatData.acf.manualMenuItems;
                    if (Array.isArray(acfItems) && acfItems.length > 0) {
                        const processedItems = await Promise.all(acfItems.map(async (item) => {
                            if (!item.link || !item.link.url) return null;

                            let thumbObj = null;
                            if (item.image) {
                                let imageUrl = null;
                                let imageAlt = '';
                                let imageTitle = '';
                                let webpUrl = null;

                                if (typeof item.image === 'object' && item.image !== null) {
                                    if (item.image.sizes && item.image.sizes['post-teaser']) {
                                        imageUrl = item.image.sizes['post-teaser'];
                                    } else if (item.image.sizes && item.image.sizes.thumbnail) {
                                        imageUrl = item.image.sizes.thumbnail;
                                    } else if (item.image.url) {
                                        imageUrl = item.image.url;
                                    } else if (item.image.source_url) {
                                        imageUrl = item.image.source_url;
                                    }

                                    imageAlt = item.image.alt || item.image.alt_text || '';
                                    imageTitle = item.image.title || '';

                                    imageUrl = normalizeImageUrl(imageUrl);
                                    if (imageUrl) {
                                        const baseUrl = imageUrl;
                                        if (baseUrl.match(/\.(jpg|jpeg|png)$/i)) {
                                            webpUrl = baseUrl.replace(/\.(jpg|jpeg|png)$/i, '.webp');
                                        }
                                    }
                                } else if (typeof item.image === 'number') {
                                    const imageId = item.image;
                                    try {
                                        const baseUrl = (typeof wpUrls !== 'undefined' && wpUrls.baseUrl) ? wpUrls.baseUrl : window.location.origin;
                                        const response = await axios.get(`${baseUrl}/wp-json/wp/v2/media/${imageId}`);
                                        const attachment = response.data;

                                        if (attachment.media_details && attachment.media_details.sizes && attachment.media_details.sizes['post-teaser']) {
                                            imageUrl = attachment.media_details.sizes['post-teaser'].source_url;
                                        } else if (attachment.media_details && attachment.media_details.sizes && attachment.media_details.sizes.thumbnail) {
                                            imageUrl = attachment.media_details.sizes.thumbnail.source_url;
                                        } else if (attachment.source_url) {
                                            imageUrl = attachment.source_url;
                                        }

                                        imageAlt = attachment.alt_text || '';
                                        imageTitle = attachment.title?.rendered || '';

                                    } catch (error) {
                                        imageUrl = null;
                                    }
                                }

                                imageUrl = normalizeImageUrl(imageUrl);
                                webpUrl = normalizeImageUrl(webpUrl);
                                if (imageUrl) {
                                    thumbObj = {
                                        url: imageUrl,
                                        webpUrl: webpUrl,
                                        alt: imageAlt,
                                        title: imageTitle
                                    };
                                }
                            }

                            return {
                                id: `rest_item_${Math.random()}`,
                                title: item.title || item.link.title || '',
                                subline: item.subline || '',
                                url: item.link.url,
                                target: item.link.target || '',
                                thumb: thumbObj
                            };
                        }));
                        manualMenuItems = processedItems.filter(x => x !== null);
                    }
                }
            } else if (typeof wpUrls !== 'undefined' && wpUrls.manualMenuItems
                && Array.isArray(wpUrls.manualMenuItems) && wpUrls.manualMenuItems.length > 0) {
                manualMenuItems = wpUrls.manualMenuItems;
            }

            if (manualMenuItems && manualMenuItems.length > 0) {
                const formattedPosts = manualMenuItems.map((item) => {
                    let finalThumb = null;

                    if (item.thumb) {
                        if (typeof item.thumb === 'object' && normalizeImageUrl(item.thumb.url)) {
                            finalThumb = {
                                url: normalizeImageUrl(item.thumb.url),
                                webpUrl: normalizeImageUrl(item.thumb.webpUrl),
                                alt: item.thumb.alt || '',
                                title: item.thumb.title || ''
                            };
                        }
                    }

                    let titleRendered = '';
                    if (typeof item.title === 'object' && item.title.rendered) {
                        titleRendered = item.title.rendered;
                    } else {
                        titleRendered = item.title || '';
                    }

                    return {
                        id: item.id,
                        title: { rendered: titleRendered },
                        permalink: item.url,
                        target: item.target || '_self',
                        thumb: finalThumb,
                        filledexcerpt: item.subline || '',
                        acf: {}
                    };
                });
                commit('SET_MANUEL_OVERRIDE_POSTS', formattedPosts);
            } else {
                commit('SET_MANUEL_OVERRIDE_POSTS', null);
            }
        },
        setMagazineCat({ state, commit, dispatch }) {
            let currentMagazineCat = null;
            /* eslint-disable-next-line */
            const magazineCat = parseInt(wpUrls.magazineCat, 10);
            const storagemagazineCat = parseInt(localStorage.getItem('magazineCat'), 10);
            /* eslint-disable-next-line */
            const magazineCatFallback = parseInt(wpUrls.magazineCatFallback, 10);
            const magazineCatParam = parseInt(queryString.parse(window.location.search).mc, 10);

            if (!Number.isNaN(magazineCat) && magazineCat > 0) {
                currentMagazineCat = magazineCat;
            } else if (!Number.isNaN(magazineCatParam) && magazineCatParam > 0) {
                currentMagazineCat = magazineCatParam;
            } else if (!Number.isNaN(storagemagazineCat) && storagemagazineCat > 0) {
                currentMagazineCat = storagemagazineCat;
            } else if (!Number.isNaN(magazineCatFallback) && magazineCatFallback > 0) {
                currentMagazineCat = magazineCatFallback;
            }

            if (state.magazineCat !== null && state.magazineCat === currentMagazineCat) {
                return;
            }

            if (currentMagazineCat !== null && !Number.isNaN(currentMagazineCat)) {
                window.history.replaceState(
                    null,
                    null,
                    queryString.stringifyUrl({ url: window.location.href, query: { mc: currentMagazineCat } })
                );
                localStorage.setItem('magazineCat', currentMagazineCat);
                const magazinSearchCat = document.querySelectorAll('#magazinSearch [name=magazinecat]');
                const shareLink = document.querySelectorAll('.shareLink');

                if (magazinSearchCat && magazinSearchCat.length > 0) {
                    magazinSearchCat[0].value = currentMagazineCat;
                }

                // Search Input on Results Page
                if (document.querySelectorAll('body.search-results').length) {
                    const mainSearchMagazinSearchCat = document.querySelectorAll('#mainSearch [name=magazinecat]');

                    if (mainSearchMagazinSearchCat && mainSearchMagazinSearchCat.length > 0) {
                        mainSearchMagazinSearchCat[0].value = currentMagazineCat;
                    }
                }

                if (shareLink.length) {
                    for (let shareLinkIndex = 0; shareLinkIndex < shareLink.length; shareLinkIndex++) {
                        const link = shareLink[shareLinkIndex];
                        link.setAttribute('href', `${link.getAttribute('href')}?mc=${currentMagazineCat}`);
                    }
                }
            }

            commit('SET_MAGAZINE_CAT', currentMagazineCat);

            if (currentMagazineCat !== null && !Number.isNaN(currentMagazineCat)) {
                dispatch('setMagazineCatData', currentMagazineCat);
            }
        },
        setPagination({ state, commit }) {
            /* eslint-disable-next-line */
            const currentId = wpUrls.currentID;
            const indexCurrent = state.filteredPosts.findIndex((post) => post.id === parseInt(currentId, 10));

            let filteredPostsCount = state.filteredPosts.length + 1;
            if (filteredPostsCount < 10) {
                filteredPostsCount = `0${state.filteredPosts.length + 1}`;
            }

            if (indexCurrent >= 0) {
                if (indexCurrent + 1 !== state.filteredPosts.length) {
                    commit('SET_NEXT_POST', state.filteredPosts[indexCurrent + 1]);
                }

                if (indexCurrent === 0) {
                    commit('SET_PREV_POST', state.startPage);
                } else {
                    commit('SET_PREV_POST', state.filteredPosts[indexCurrent - 1]);
                }

                commit('SET_POST_COUNT', `${indexCurrent + 2}/${filteredPostsCount}`);
                if (indexCurrent + 2 < 10) {
                    commit('SET_POST_COUNT', `0${indexCurrent + 2}/${filteredPostsCount}`);
                }
            } else {
                [state.nextPost] = state.filteredPosts;
                commit('SET_POST_COUNT', `01/${filteredPostsCount}`);
            }
        },
        async setPages({ state, commit }) {
            if (state.pages.length) return;
            try {
                const pages = await axios.get(`${window.wpUrls.baseUrl}/wp-json/wp/v2/pages`, {
                    params: {
                        _embed: true,
                        _fields: 'title, id, thumb, permalink, acf, content',
                        per_page: 9999,
                    }
                });
                commit('SET_PAGES', pages.data);
                if (state.magazineCat !== null) {
                    commit('SET_START_PAGE', pages.data.find((page) => page.acf.magazineCat === state.magazineCat));
                }
            } catch (err) {
                /* eslint-disable-next-line */
                console.error('setPages', err)
            }
        },
        async setPosts({ state, commit }) {
            if (state.posts.length) return;
            try {
                const posts = await axios.get(`${window.wpUrls.baseUrl}/wp-json/wp/v2/magazin`, {
                    params: {
                        _embed: true,
                        /* eslint-disable-next-line */
                        _fields: 'title, id, thumb, permalink, acf, magazinecat, primarymagazinecat, filledexcerpt',
                        per_page: 9999,
                    }
                });
                commit('SET_POSTS', posts.data);

                commit('SET_FILTERED_POSTS', posts.data.filter((post) => post.magazinecat
                    .some((cat) => cat === state.magazineCat)).sort((a, z) => {
                    const aPage = getMagazinPageEntry(a, state.magazineCat);
                    const zPage = getMagazinPageEntry(z, state.magazineCat);

                    if (aPage && zPage) {
                        return aPage.page - zPage.page;
                    }
                    if (aPage) {
                        return -1;
                    }
                    if (zPage) {
                        return 1;
                    }
                    return 0;
                }));
            } catch (err) {
                /* eslint-disable-next-line */
                console.error('getPosts', err)
            }
        },
        async setMagazineCatData({ commit, dispatch }, categoryId) {
            if (!categoryId) {
                commit('SET_MAGAZINE_CAT_DATA', null);
                dispatch('setManuelOverridePosts');
                return null;
            }

            commit('SET_MAGAZINE_CAT_DATA', null);

            try {
                const response = await axios.get(`${window.wpUrls.baseUrl}/wp-json/wp/v2/magazinecat/${categoryId}`);
                commit('SET_MAGAZINE_CAT_DATA', response.data);
                dispatch('setManuelOverridePosts');

                return response.data;
            } catch (err) {
                commit('SET_MAGAZINE_CAT_DATA', { _restApiFailed: true, id: categoryId });
                dispatch('setManuelOverridePosts');
                return null;
            }
        },
    },
});

export default store;
